/** @format */

import { BehaviorSubject } from 'rxjs';
import { ISnackbarInfo } from '@shared/data-access/interfaces';
import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly snackbar$: BehaviorSubject<ISnackbarInfo> = new BehaviorSubject<ISnackbarInfo>({
    isAuthSnackbar: false,
    showSnackbar: false,
  });

  public snackbar = this.snackbar$.asObservable();

  public showSnackBar(snackbarInfo: ISnackbarInfo) {
    this.snackbar$.next(snackbarInfo);
  }

  public hideSnackBar() {
    this.snackbar$.next({ isAuthSnackbar: false, showSnackbar: false });
  }
}
